/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssignCouponsToUserRequest,
    AvailableAssignToUserCouponsResponse,
    AvailableCouponsResponseDto,
    CouponDetailResponse,
    CreateCouponByAdminDto,
    CreateCouponBySellerDto,
    CreateCouponResponse,
    EditCouponByAdminDto,
    EditCouponBySellerDto,
    MyCouponDto,
    MyCouponsResponseDto,
    RedeemCouponRequest,
} from '../models';

export interface CouponApiControllerAssignCouponsToUserRequest {
    sellerId: string;
    assignCouponsToUserRequest: AssignCouponsToUserRequest;
}

export interface CouponApiControllerCreateCouponByAdminRequest {
    createCouponByAdminDto: CreateCouponByAdminDto;
}

export interface CouponApiControllerCreateCouponBySellerRequest {
    sellerId: string;
    createCouponBySellerDto: CreateCouponBySellerDto;
}

export interface CouponApiControllerDisableCouponRequest {
    couponId: string;
}

export interface CouponApiControllerEditCouponByAdminRequest {
    couponId: string;
    editCouponByAdminDto: EditCouponByAdminDto;
}

export interface CouponApiControllerEditCouponBySellerRequest {
    sellerId: string;
    couponId: string;
    editCouponBySellerDto: EditCouponBySellerDto;
}

export interface CouponApiControllerEnableCouponRequest {
    couponId: string;
}

export interface CouponApiControllerGetAvailableAssignToUserCouponsRequest {
    sellerId: string;
}

export interface CouponApiControllerGetAvailableCouponsRequest {
    sellerId?: string;
}

export interface CouponApiControllerGetCouponDetailRequest {
    couponId: string;
    sellerId?: string;
}

export interface CouponApiControllerGetMyCouponsRequest {
    userId: string;
}

export interface CouponApiControllerRedeemCouponRequest {
    code: string;
    redeemCouponRequest?: RedeemCouponRequest;
}

/**
 * 
 */
export class CouponApi extends runtime.BaseAPI {

    /**
     */
    async couponApiControllerAssignCouponsToUserRaw(requestParameters: CouponApiControllerAssignCouponsToUserRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling couponApiControllerAssignCouponsToUser.');
        }

        if (requestParameters.assignCouponsToUserRequest === null || requestParameters.assignCouponsToUserRequest === undefined) {
            throw new runtime.RequiredError('assignCouponsToUserRequest','Required parameter requestParameters.assignCouponsToUserRequest was null or undefined when calling couponApiControllerAssignCouponsToUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/coupons:assignToUser`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.assignCouponsToUserRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async couponApiControllerAssignCouponsToUser(requestParameters: CouponApiControllerAssignCouponsToUserRequest): Promise<void> {
        await this.couponApiControllerAssignCouponsToUserRaw(requestParameters);
    }

    /**
     */
    async couponApiControllerCreateCouponByAdminRaw(requestParameters: CouponApiControllerCreateCouponByAdminRequest): Promise<runtime.ApiResponse<CreateCouponResponse>> {
        if (requestParameters.createCouponByAdminDto === null || requestParameters.createCouponByAdminDto === undefined) {
            throw new runtime.RequiredError('createCouponByAdminDto','Required parameter requestParameters.createCouponByAdminDto was null or undefined when calling couponApiControllerCreateCouponByAdmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/coupons`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createCouponByAdminDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async couponApiControllerCreateCouponByAdmin(requestParameters: CouponApiControllerCreateCouponByAdminRequest): Promise<CreateCouponResponse> {
        const response = await this.couponApiControllerCreateCouponByAdminRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async couponApiControllerCreateCouponBySellerRaw(requestParameters: CouponApiControllerCreateCouponBySellerRequest): Promise<runtime.ApiResponse<CreateCouponResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling couponApiControllerCreateCouponBySeller.');
        }

        if (requestParameters.createCouponBySellerDto === null || requestParameters.createCouponBySellerDto === undefined) {
            throw new runtime.RequiredError('createCouponBySellerDto','Required parameter requestParameters.createCouponBySellerDto was null or undefined when calling couponApiControllerCreateCouponBySeller.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/coupons`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createCouponBySellerDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async couponApiControllerCreateCouponBySeller(requestParameters: CouponApiControllerCreateCouponBySellerRequest): Promise<CreateCouponResponse> {
        const response = await this.couponApiControllerCreateCouponBySellerRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async couponApiControllerDisableCouponRaw(requestParameters: CouponApiControllerDisableCouponRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.couponId === null || requestParameters.couponId === undefined) {
            throw new runtime.RequiredError('couponId','Required parameter requestParameters.couponId was null or undefined when calling couponApiControllerDisableCoupon.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/coupons/{couponId}:disable`.replace(`{${"couponId"}}`, encodeURIComponent(String(requestParameters.couponId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async couponApiControllerDisableCoupon(requestParameters: CouponApiControllerDisableCouponRequest): Promise<void> {
        await this.couponApiControllerDisableCouponRaw(requestParameters);
    }

    /**
     */
    async couponApiControllerEditCouponByAdminRaw(requestParameters: CouponApiControllerEditCouponByAdminRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.couponId === null || requestParameters.couponId === undefined) {
            throw new runtime.RequiredError('couponId','Required parameter requestParameters.couponId was null or undefined when calling couponApiControllerEditCouponByAdmin.');
        }

        if (requestParameters.editCouponByAdminDto === null || requestParameters.editCouponByAdminDto === undefined) {
            throw new runtime.RequiredError('editCouponByAdminDto','Required parameter requestParameters.editCouponByAdminDto was null or undefined when calling couponApiControllerEditCouponByAdmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/coupons/{couponId}`.replace(`{${"couponId"}}`, encodeURIComponent(String(requestParameters.couponId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editCouponByAdminDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async couponApiControllerEditCouponByAdmin(requestParameters: CouponApiControllerEditCouponByAdminRequest): Promise<void> {
        await this.couponApiControllerEditCouponByAdminRaw(requestParameters);
    }

    /**
     */
    async couponApiControllerEditCouponBySellerRaw(requestParameters: CouponApiControllerEditCouponBySellerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling couponApiControllerEditCouponBySeller.');
        }

        if (requestParameters.couponId === null || requestParameters.couponId === undefined) {
            throw new runtime.RequiredError('couponId','Required parameter requestParameters.couponId was null or undefined when calling couponApiControllerEditCouponBySeller.');
        }

        if (requestParameters.editCouponBySellerDto === null || requestParameters.editCouponBySellerDto === undefined) {
            throw new runtime.RequiredError('editCouponBySellerDto','Required parameter requestParameters.editCouponBySellerDto was null or undefined when calling couponApiControllerEditCouponBySeller.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/coupons/{couponId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"couponId"}}`, encodeURIComponent(String(requestParameters.couponId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editCouponBySellerDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async couponApiControllerEditCouponBySeller(requestParameters: CouponApiControllerEditCouponBySellerRequest): Promise<void> {
        await this.couponApiControllerEditCouponBySellerRaw(requestParameters);
    }

    /**
     */
    async couponApiControllerEnableCouponRaw(requestParameters: CouponApiControllerEnableCouponRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.couponId === null || requestParameters.couponId === undefined) {
            throw new runtime.RequiredError('couponId','Required parameter requestParameters.couponId was null or undefined when calling couponApiControllerEnableCoupon.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/coupons/{couponId}:enable`.replace(`{${"couponId"}}`, encodeURIComponent(String(requestParameters.couponId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async couponApiControllerEnableCoupon(requestParameters: CouponApiControllerEnableCouponRequest): Promise<void> {
        await this.couponApiControllerEnableCouponRaw(requestParameters);
    }

    /**
     */
    async couponApiControllerGetAvailableAssignToUserCouponsRaw(requestParameters: CouponApiControllerGetAvailableAssignToUserCouponsRequest): Promise<runtime.ApiResponse<AvailableAssignToUserCouponsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling couponApiControllerGetAvailableAssignToUserCoupons.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/coupons:getAvailableAssignToUserCoupons`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async couponApiControllerGetAvailableAssignToUserCoupons(requestParameters: CouponApiControllerGetAvailableAssignToUserCouponsRequest): Promise<AvailableAssignToUserCouponsResponse> {
        const response = await this.couponApiControllerGetAvailableAssignToUserCouponsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async couponApiControllerGetAvailableCouponsRaw(requestParameters: CouponApiControllerGetAvailableCouponsRequest): Promise<runtime.ApiResponse<AvailableCouponsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/coupons`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async couponApiControllerGetAvailableCoupons(requestParameters: CouponApiControllerGetAvailableCouponsRequest): Promise<AvailableCouponsResponseDto> {
        const response = await this.couponApiControllerGetAvailableCouponsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async couponApiControllerGetCouponDetailRaw(requestParameters: CouponApiControllerGetCouponDetailRequest): Promise<runtime.ApiResponse<CouponDetailResponse>> {
        if (requestParameters.couponId === null || requestParameters.couponId === undefined) {
            throw new runtime.RequiredError('couponId','Required parameter requestParameters.couponId was null or undefined when calling couponApiControllerGetCouponDetail.');
        }

        const queryParameters: any = {};

        if (requestParameters.sellerId !== undefined) {
            queryParameters['sellerId'] = requestParameters.sellerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/coupons/{couponId}`.replace(`{${"couponId"}}`, encodeURIComponent(String(requestParameters.couponId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async couponApiControllerGetCouponDetail(requestParameters: CouponApiControllerGetCouponDetailRequest): Promise<CouponDetailResponse> {
        const response = await this.couponApiControllerGetCouponDetailRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async couponApiControllerGetMyCouponsRaw(requestParameters: CouponApiControllerGetMyCouponsRequest): Promise<runtime.ApiResponse<MyCouponsResponseDto>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling couponApiControllerGetMyCoupons.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/coupons`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async couponApiControllerGetMyCoupons(requestParameters: CouponApiControllerGetMyCouponsRequest): Promise<MyCouponsResponseDto> {
        const response = await this.couponApiControllerGetMyCouponsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async couponApiControllerRedeemCouponRaw(requestParameters: CouponApiControllerRedeemCouponRequest): Promise<runtime.ApiResponse<MyCouponDto>> {
        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling couponApiControllerRedeemCoupon.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/coupons/{code}:redeem`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.redeemCouponRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async couponApiControllerRedeemCoupon(requestParameters: CouponApiControllerRedeemCouponRequest): Promise<MyCouponDto> {
        const response = await this.couponApiControllerRedeemCouponRaw(requestParameters);
        return await response.value();
    }

}
